export default __webpack_public_path__ + "static/media/RhymesColors_02.20a86bab.png";